import { TicketSelectionApplicationData } from "@/domain/ticket-selection";
import { PriceLevel, PromotionHold } from "webshop-api";

export class PriceListValidityProvider {

    /**
     * whatItDoes
     * removes priceLevels without valid promotionHolds
     */
    public static provideValidPriceListForApplication(data: TicketSelectionApplicationData): TicketSelectionApplicationData {
        if (!data.priceList) {
            return data;
        }

        if (!data.priceList.priceLevels) {
            return data;
        }

        if (!data.priceList.priceLevels.length) {
            return data;
        }

        data.priceList.priceLevels = data.priceList.priceLevels
            .map(priceLevel => this.provideValidPromotionHolds(priceLevel))
            .filter(priceLevel => priceLevel.promotionHolds && priceLevel.promotionHolds.length)

        return data;
    }

    /**
     * whatItDoes
     * removes promotionHolds without valid Holds
     */
    private static provideValidPromotionHolds(priceLevel: PriceLevel): PriceLevel {
        if (!priceLevel.promotionHolds) {
            return priceLevel;
        }

        priceLevel.promotionHolds = priceLevel.promotionHolds
            .map(promotionHold => this.provideValidHolds(promotionHold))
            .filter(promotionHold => promotionHold.holds && promotionHold.holds.length);

        return priceLevel;
    }

    /**
     * whatItDoes
     * removes holds without valid ticketTypes
     */
    private static provideValidHolds(promotionHold: PromotionHold): PromotionHold {
        if (!promotionHold.holds) {
            return promotionHold;
        }

        promotionHold.holds = promotionHold.holds.filter(hold => hold.ticketTypes && hold.ticketTypes.length)

        return promotionHold;
    }

}
